import I18n from 'I18n';
import { find } from 'underscore';
import { getFormsLangToLang } from 'FormsUI/utils/Lang';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"property-translator/propertyTranslator"' ... Remove this comment to see the full error message
import { makeNameSpacedKey } from 'property-translator/propertyTranslator';
import Log from 'forms-utils-lib/logger/Logger';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { DEFAULT_LANG } from 'FormsCommonComponents/js/constants/Languages';
import { FORM_FIELD_ERROR_TYPES } from 'FormsUI/constants/FormFieldErrorTypes';
import getPathIdentifier from 'forms-utils-lib/formField/utils/getPathIdentifier';
import getConfigurationType from 'forms-utils-lib/formField/utils/getConfigurationType';
export const i18nLookupAndText = (...args) => {
  const temp = I18n.lookup(...args);
  // @ts-expect-error ts-migrate(2556) FIXME: A spread argument must either have a tuple type or... Remove this comment to see the full error message
  return temp && typeof temp !== 'function' && I18n.text(...args);
};
export function getOptionsForSelect(formFieldOptions) {
  const selectOptions = [];
  formFieldOptions.forEach(formFieldOption => {
    selectOptions.push({
      text: formFieldOption.label,
      value: formFieldOption.value
    });
  });
  return selectOptions;
}
export function getFormFieldLabel(label, specificLocale) {
  const translationOptions = Object.assign({}, specificLocale && {
    locale: getFormsLangToLang(specificLocale)
  });
  const key = makeNameSpacedKey(label);
  const englishTextForLabelAsKey = i18nLookupAndText(key, {
    locale: DEFAULT_LANG
  });

  // The English "translation" for the label as a key is not the label coming in, so the translation won't be either
  // we can't confidently use this label as a key to translate.
  const isEnglishTranslationEmptyOrNotOriginalLabel = !englishTextForLabelAsKey || englishTextForLabelAsKey.toLowerCase() !== label.toLowerCase();
  return isEnglishTranslationEmptyOrNotOriginalLabel ? label : i18nLookupAndText(key, translationOptions) || label;
}
export function getMetaDataValue(metaData, key) {
  // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
  const value = (find(metaData, {
    name: key
  }) || {}).value;
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }
  return value;
}
export function setMetaDataValue(metaData, key, value) {
  const metaDataWithoutKey = metaData.filter(item => item.name !== key);
  if (value === undefined || value === null) {
    return metaDataWithoutKey;
  }
  return [...metaDataWithoutKey, {
    name: key,
    value: value.toString()
  }];
}
export function getSupportedFormFieldTypeOrText(field) {
  const supportedFields = [...Object.values(FieldTypes)];
  if (!supportedFields.includes(field.fieldType)) {
    // TODO: Change to error when form field validation rolled out
    Log.warn('formField.fieldType did not have a supported field type', {
      field
    });
    return 'text';
  }
  return field.fieldType;
}
export const isInvalidFormField = (formField, invalidFormField) => formField.objectTypeId === invalidFormField.objectTypeId && formField.name === invalidFormField.propertyName;
export const getFormFieldError = ({
  formField,
  invalidProperty,
  formDefinitionUpdateErrors
}) => {
  const invalidFormField = isInvalidFormField(formField, invalidProperty);
  const formFieldIdentifier = getPathIdentifier(formField);
  const formFieldUpdateError = formDefinitionUpdateErrors[formFieldIdentifier];
  const hasFormFieldUpdateErrors = formFieldUpdateError && formFieldUpdateError.length > 0;
  const formFieldUpdateErrorType = hasFormFieldUpdateErrors ? formFieldUpdateError[0].formFieldValidationErrorOption : null;
  if (!formField.name) {
    return {
      type: FORM_FIELD_ERROR_TYPES.NO_FIELD_NAME,
      key: null
    };
  } else if (invalidFormField) {
    return {
      type: FORM_FIELD_ERROR_TYPES.INVALID_FORM_FIELD,
      key: null
    };
  } else if (formFieldUpdateErrorType) {
    return {
      type: FORM_FIELD_ERROR_TYPES.UPDATE_ERROR,
      key: formFieldUpdateErrorType
    };
  } else {
    return null;
  }
};
export const isPathIndentifierInFields = (fields, pathIdentifier) => fields.some(field => getPathIdentifier(field) === pathIdentifier);
export const updatePrivateInternalIdsOnFieldGroups = updatedFormFieldGroups => updatedFormFieldGroups.reduce((acc, formFieldGroup) => [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
...acc, Object.assign({}, formFieldGroup, {
  richText: Object.assign({}, formFieldGroup.richText, {
    privateInternalId: acc.length + 1
  })
})], []);
export const isFieldAPaymentField = field => {
  return getConfigurationType(field) === FieldTypes.PAYMENT_RADIO;
};
export const getIsHiddenOptionDisabled = formField => {
  if (isFieldAPaymentField(formField)) {
    return true;
  }
  return false;
};
export const isEveryOptionPopulated = options => {
  return options && options.length && options.every(({
    value
  }) => value);
};